import { ControlledTextField } from '@if/mui'
import FormDialog from '@src/components/Common/Dialog/FormDialog'
import { useUnmountableDialog } from '@src/services/dialog'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface NoteDialogProps {
  onConfirm: (note: string) => void
  onClose: () => void
}

const NoteDialog = ({ onConfirm, onClose }: NoteDialogProps) => {
  const { t } = useTranslation()
  const { dialogProps, closeDialog } = useUnmountableDialog(onClose)
  const { control, handleSubmit } = useForm<{ note: string }>()

  const handleConfirm = handleSubmit((data) => {
    onConfirm(data.note)
    closeDialog()
  })

  return (
    <FormDialog {...dialogProps} onConfirm={handleConfirm} title={t('loan.payment.options.addNote')}>
      <ControlledTextField
        control={control}
        name="note"
        label={t('loan.payment.description')}
        placeholder={t('loan.payment.options.addNote')}
        autoFocus
      />
    </FormDialog>
  )
}

export default NoteDialog
